var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', _vm._g({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "54",
      "height": "55"
    }
  }, _vm.$listeners), [_c('g', {
    attrs: {
      "fill": "#005149",
      "fill-rule": "evenodd"
    }
  }, [_c('path', {
    attrs: {
      "d": "M26.755 53.048c-13.924 0-25.253-11.329-25.253-25.254S12.831 2.54 26.755 2.54c13.925 0 25.255 11.33 25.255 25.254S40.68 53.048 26.755 53.048m0-52.01C12.002 1.038 0 13.041 0 27.794S12.002 54.55 26.755 54.55c14.754 0 26.755-12.002 26.755-26.755S41.509 1.039 26.755 1.039"
    }
  }), _c('path', {
    attrs: {
      "d": "m12.19 28.047 6.453-6.41a.933.933 0 0 0-.665-1.596.93.93 0 0 0-.664.273l-7.12 7.072a.92.92 0 0 0-.275.66c0 .25.097.485.275.66l7.12 7.072c.167.168.417.25.664.263a.95.95 0 0 0 .665-.263.92.92 0 0 0 .276-.66.92.92 0 0 0-.276-.66zm30.453-.66-7.118-7.073a.94.94 0 0 0-.665-.273.94.94 0 0 0-.666.272.927.927 0 0 0 0 1.321l6.454 6.412-6.454 6.411a.92.92 0 0 0-.275.66.92.92 0 0 0 .941.924.95.95 0 0 0 .665-.263l7.118-7.071a.92.92 0 0 0 .276-.66.92.92 0 0 0-.276-.66M29.166 16.068a1 1 0 0 0-.24-.027c-.457 0-.854.285-.964.693l-6.014 22.17a.86.86 0 0 0 .112.693c.137.21.354.358.61.417.252.058.517.02.749-.107a.92.92 0 0 0 .456-.56l6.014-22.17a.85.85 0 0 0-.111-.692.99.99 0 0 0-.612-.417"
    }
  })])]);

}
var staticRenderFns = []

export { render, staticRenderFns }